import moment from 'moment';

import { config } from "../../config";
import { EVCBayOutlet, EVCBayOutletGun, EVCStationBaySetup, EVCStationBayStatus } from "../../entity/station/evcbay";
import { StationTransformer } from './evcstation';
import { EVChargerTransformer } from './evcharger';
import { EVChargeTariff } from '../../entity/station/evcharge-tariff';

export class EVCBayOutletGunTransformer {
    transform(gunInfo: any): EVCBayOutletGun {
        let gun = new EVCBayOutletGun(
            gunInfo.portId,
            gunInfo.portName,
            config.api.host + "/common/static/images/" + gunInfo.portImage,
            gunInfo.primaryTitle,
            gunInfo.secondaryTitle,
            gunInfo.additionalTitle,
            // 08-05-2025 chargerTypeGroup added for displaying to user
            gunInfo.chargerTypeGroup
        )
        return gun
    }
}